import { render, staticRenderFns } from "./page-b.vue?vue&type=template&id=714691f3&scoped=true&lang=pug&"
import script from "./page-b.vue?vue&type=script&lang=js&"
export * from "./page-b.vue?vue&type=script&lang=js&"
import style0 from "./page-b.vue?vue&type=style&index=0&id=714691f3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714691f3",
  null
  
)

export default component.exports